import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdateTenderStageMutationRequest, UpdateTenderStageMutationResponse, UpdateTenderStageQueryParams } from "../../types/UpdateTenderStage";

/**
     * @link /api/purchase-tenders/private/v1/stage
     */
export async function updateTenderStage (data: UpdateTenderStageMutationRequest, params: UpdateTenderStageQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<UpdateTenderStageMutationResponse>["data"]> {
    const { data: resData } = await client<UpdateTenderStageMutationResponse, UpdateTenderStageMutationRequest>({
        method: "put",
        url: `/api/purchase-tenders/private/v1/stage`,
        params,
        data,
        ...options
    });
    
    return resData;
};